export default {
    dependencies: ['$element', 'searchmanager', 'templateservice'],
    callable(ele, searchmanager, templateservice) {
        const button = ele.querySelector('[data-state]');
        const showSomeUnitsArgs = searchmanager.currentQuery;

        const showAllUnitsArgs = { showAll: [true] };
        Object.keys(showSomeUnitsArgs).forEach(key => {
            showAllUnitsArgs[key] = showSomeUnitsArgs[key];
        });

        let args = showAllUnitsArgs;

        button.addEventListener('click', handleClick);

        function handleClick() {
            searchmanager.search(args).then(renderUnits);
            swapButton();
        }

        function renderUnits(result) {
            const container = ele.querySelector('[data-unitlist]');
            container.innerHTML = templateservice.render(
                'ad-section-units',
                result
            );
        }

        function swapButton() {
            if (button.getAttribute('data-state') === 'showAll') {
                button.textContent = 'Vis kun boliger som passer søket mitt';
                button.setAttribute('data-state', 'showSome');
                args = showSomeUnitsArgs;
            } else {
                button.textContent = 'Vis alle boliger';
                button.setAttribute('data-state', 'showAll');
                args = showAllUnitsArgs;
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/showAllUnits.js